import { getAllServicesApiRequest, getAllSessionsApiRequest, getClassesApiRequest } from '@guryou/api-client';
import { getWebIntegrationApiRequest } from '@guryou/api-client-gql';

import { buildActionType, executeApiCall } from '../core';
import { WIDGET_CLASSES, WIDGET_INTEGRATION, WIDGET_RESOURCES_SET, WIDGET_SERVICES, WIDPROVIDER_SESSIONS_GET_MANY } from '../types';

import { execute } from './actionWrapper';

const widgetGetIntegration = id => async dispatch => execute(dispatch, () => getWebIntegrationApiRequest(+id), WIDGET_INTEGRATION);

const widgetGetServices = pid => async dispatch => dispatch(executeApiCall(getAllServicesApiRequest(pid), WIDGET_SERVICES, false, null, true));

const widgetResetResources = () => async dispatch => dispatch({ type: buildActionType(WIDGET_RESOURCES_SET), payload: [] });

const widgetGetClasses = id => async dispatch => dispatch(executeApiCall(getClassesApiRequest(id, true), WIDGET_CLASSES, false, null, true));

const widgetGetSessions = id => async dispatch =>
  dispatch(executeApiCall(getAllSessionsApiRequest(id, true), WIDPROVIDER_SESSIONS_GET_MANY, false, null, true));

export { widgetGetClasses, widgetGetIntegration, widgetGetServices, widgetGetSessions, widgetResetResources };
